import { render } from "./NotificationPanel.vue?vue&type=template&id=35cb1fdd&scoped=true"
import script from "./NotificationPanel.vue?vue&type=script&lang=js"
export * from "./NotificationPanel.vue?vue&type=script&lang=js"

import "./NotificationPanel.vue?vue&type=style&index=0&id=35cb1fdd&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cb1fdd"]])

export default __exports__